import { metaService } from '../services'

const state = {
  all: {
    countries: null
  }
}

const actions = {
  getRoles ({ commit }) {
    return new Promise((resolve) => {
      resolve([
        {
          key: 'Staff',
          value: 'Anställd'
        }
      ])
    })
  },

  getPermissions ({ commit }) {
    return new Promise((resolve) => {
      resolve([
        {
          key: 'EditUsers',
          value: 'Hantera användare'
        },
        {
          key: 'EditCustomers',
          value: 'Hantera kunder'
        },
        {
          key: 'EditLicenses',
          value: 'Hantera licenser'
        },
        {
          key: 'SystemSettings',
          value: 'Systeminställningar'
        },
        {
          key: 'DeveloperTools',
          value: 'Developer tools'
        }
      ])
    })
    // return metaService.getPermissions().then(data => {
    //   return data.result
    // })
  },

  getDatabaseTableMetrics ({ commit }) {
    return metaService.getDatabaseTableMetrics().then(data => {
      return data.result
    })
  },

  getUserRoleMetrics ({ commit }) {
    return metaService.getUserRoleMetrics().then(data => {
      return data.result
    })
  },

  getCountries ({ commit }) {
    return metaService.getCountries().then(data => {
      commit('getCountriesSuccess', data.result)
      return data.result
    })
  }
}

const mutations = {
  getCountriesSuccess (state, items) {
    state.all.countries = items
  }
}

const getters = {
}

export const meta = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/meta.module.js